var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component case-overview-component"},[_c('case-overview',{attrs:{"data":_vm.data,"menuType":_vm.menuType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }